import {useEffect} from 'react'
import { Col, Row } from 'react-bootstrap'
import FloatingButtons from './FloatingButtons'

export default function Cancellation() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [])
    return (
        <>
        <FloatingButtons/>
        <section className='cs-bg-dark py-4 cs-section'>
            <div className='container text-white'>
                <Row>
                    <Col xs={12} md={4}>
                        <img className='rounded' width={'100%'} src="/assets/frontend/images/bbrboat.webp"/>
                    </Col>
                    <Col xs={12} md={8}>
                        <Row className=''>
                            <Col xs={12} className='d-flex flex-column margin-top-mobile-40'>
                                <h1>Cancellation</h1>
                                <h4 className='mt-3'>BBR Default Cancellation Policy</h4>
                                <p className='m-0'>(Applies when a boat owner does not display their own custom policy)</p>
                                <h4 className='mt-3'>Weather-Related Cancellations</h4>
                                <p className='m-0'>Boat owners are not required to cancel a reservation due to weather conditions unless there is a named storm at the pickup location. Any weather-related cancellation is at the sole discretion of the boat owner.</p>
                               
                                <h4 className='mt-3'>Standard Cancellation Terms</h4>
                                    <p className='m-0'>14 days or more before rental date
                                        Full refund issued.
                                        <br />
                                        Within 14 days and up to 48 hours before rental
                                        20% deposit is forfeited.
                                        <br />
                                        Within 48 hours of rental start time
                                        Full rental amount is charged, unless the booking is rescheduled to a new date within 90 days of the original reservation.
                                        <br />
                                        No-shows
                                        Full rental amount will be charged.</p>
                               
                                <h4 className='mt-4'>Fishing Tournament Cancellations</h4>
                                    <p className='m-0'>
                                        If a tournament is cancelled before the rental begins by the tournament director, the boat owner may cancel and refund the reservation.
                                        <br />
                                        If a tournament is cancelled after the rental has started, the boat owner may issue a prorated refund based on unused rental days.
                                        <br />
                                        Example:
                                        If a 2-day rental costs $700 and a 1-day rental costs $500, returning the boat one day early may result in a $200 refund.
                                        <br />
                                        All tournament-related refunds are guidelines and are negotiable between the boat owner and renter. Both parties are encouraged to act fairly and reasonably to maintain positive future rental relationships.
                                        <br />
                                        BBR is not responsible for mediating or resolving refund disputes between boat owners and renters.</p>
                                {/* <h4 className='mt-4'>Cancellation policy</h4>
                                <p className='m-0'>If cancellation occurs at least 2 weeks prior to your reservation there will be a full refund. Cancellations made by the renter within 2 weeks and up to 48 hours of the booking, will forfeit the 20% deposit. Cancellations made by the renter within 48 hours prior to your reservation will be charged the full amount unless you re-schedule to a date within 90 days of the original reservation. No shows for any reservation will be charged the full amount.
                                    <br />

 <h4 className='mt-3'>Cancellation guidelines for fishing tournaments</h4>
If the tournament event is cancelled prior to the reservation start "by the tournament director", the boat owner may cancel and refund your booking. If the tournament is cancelled on the day of the tournament "by the tournament director" after your rental has started, the boat owner may pro-rate your refund based on the daily rate e.g. if you return the boat 1 day early, the boat owner could refund the cost of that additional day rental. For example, if a 2 day rental cost $700 and a 1 day rental cost $500, a one day early return will trigger a $200 refund. All refunded fees are guidelines and are negotiable between boat owner and renter. It is recommended that both parties be fair and considerate to maintain a good relationship for all future rental opportunities. BBR is not responsible for settling refund disputes between boat owner and renter. </p> */}
                            </Col>
                        </Row>   
                    </Col>
                </Row>
            </div>
        </section>
        </>
      )
}
